import React, { useContext, useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { getPresetList } from 'gqlQueries/filterQueries';

const errorMessage: string = 'Something went wrong!';
const dummyData = {
    listData: [
        {
            label: 'kotak',
            value: 'kotak',
            isDefault: true,
        },
        {
            label: 'preset 1',
            value: 'preset 1',
            isDefault: false,
        },
        {
            label: 'preset 2',
            value: 'preset 2',
            isDefault: false,
        },
    ],
};
function useFetchAllPresets() {
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<any[] | null>(null);
    const [error, setError] = useState<string | null>(null);

    //To fetch dim
    const [fetchAllPresets, { data: timePeriod, loading: timePeriodLoading, error: timePeriodError }] = useLazyQuery(
        getPresetList,
        { fetchPolicy: 'network-only', onCompleted: onFetchComplete, onError: onFetchError },
    );

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getUserPresetsList: listData } = payload;
            const labelKey = 'presetFilterName';
            const isDefaultKey = 'defaultFlag';
            if (listData && Array.isArray(listData)) {
                const parsedData = listData.map((item: any) => {
                    return {
                        label: item?.[labelKey] + (item?.[isDefaultKey] ? ' (Default)' : ''),
                        value: item?.[labelKey],
                        isDefault: item?.[isDefaultKey],
                    };
                });
                setData(parsedData);
            }
        } catch (error) {
            onFetchError(error);
            console.error(errorMessage, error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setError(error);
        setData(null);
        setLoading(false);
    }

    return {
        loading,
        data,
        error,
        fetchAllPresets: (variables: any) => {
            setLoading(true);
            setData(null);
            fetchAllPresets(variables);
        },
    };
}

export default useFetchAllPresets;
